module.exports = __webpack_public_path__ + "img/uruguay.31bef519.svg";